import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DatePicker from 'react-datepicker';
import moment from 'moment-timezone';
import CargomaticInput from 'components/v2/input';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import i18next from 'i18next';
import DocumentUpload from './bulk-updates/DocumentUpload';
import AppointmentWindow from './bulk-updates/AppointmentWindow';
import { massUpdateActions } from '../../../constants/MassUpdates';
import ErrorAlert from '../../ui/ErrorAlert';
import { sluggify } from '../../../utils/localization/utils';
import { ARRIVAL_STOP_TYPES } from 'constants/stops';
import CargomaticSelect from 'components/v2/select';
import { getTimezones } from 'utils/Timezones';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
const CHASSIS_ID_VALID_LENGTH = 10;
class StopsGroup extends Component {
    constructor() {
        super(...arguments);
        this.handleClearAll = () => this.props.onClearAll();
        this.handleApplyToAll = (stopId) => () => this.props.onApplyToAll(stopId);
        this.handleSaveAll = () => this.props.onSaveAll();
        this.handleFieldChange = (stopId, field) => (e) => {
            const value = e.target.value;
            this.props.onFieldChange(stopId, field, value);
        };
        this.handleDateFieldChange = (stopId, field) => (momentDateObj) => {
            const dateString = momentDateObj ? momentDateObj.toISOString() : null;
            this.props.onFieldChange(stopId, field, dateString);
        };
        this.handleTimezoneChange = (stopId, field) => (tz) => {
            const timezone = tz;
            this.props.onFieldChange(stopId, field, timezone);
        };
        this.handleDrop = (stopId, jobId) => (file) => {
            this.props.onDocumentDrop(stopId, jobId, file);
        };
        this.handleDeselectShipment = (jobId) => () => this.props.onDeselectShipment(jobId);
        this.handleWindowStartChange = (stopId) => (windowDate) => {
            this.props.onFieldChange(stopId, 'window_start', windowDate);
        };
        this.handleWindowEndChange = (stopId) => (windowDate) => {
            this.props.onFieldChange(stopId, 'window_end', windowDate);
        };
        this.handleAppointmentChange = (stopId) => ({ window_start, window_end }) => this.props.onAppointmentChange(stopId, window_start, window_end);
        this.handleAppointmentConfirmationChange = (stopId, confirmAppointment) => this.props.onAppointmentConfirmationChange(stopId, confirmAppointment);
        this.handleEnableAppointmentTimes = (stopId) => () => {
            this.props.onFieldChange(stopId, 'appointment', true);
        };
        this.handleChassisChange = (stopId, chassis) => {
            const chassisData = {
                equipment_id: chassis.trim(),
                _equipmentType: 'chassis',
                _equipmentSize: '',
                _type: '',
                status: 'N/A',
            };
            this.props.onFieldChange(stopId, 'chassis', chassisData);
        };
    }
    getActionName() {
        const { updateAction, t } = this.props;
        switch (updateAction) {
            case massUpdateActions.UPDATE_APPOINTMENT_WINDOW:
                return t('UPDATE_ALL_APPOINTMENT_WINDOW');
            case massUpdateActions.COMPLETE_STOP:
                return t('COMPLETE_ALL_STOPS');
            default:
                return t('SAVE_ALL');
        }
    }
    getHeaders() {
        const { updateAction } = this.props;
        const defaultColumnHeaders = [
            { name: 'Shipment', localizationSlug: 'SHIPMENT' },
            { name: 'Address', localizationSlug: 'ADDRESS' },
            { name: 'Shipper', localizationSlug: 'SHIPPER' },
            { name: 'Equipment', localizationSlug: 'EQUIPMENT' },
        ];
        switch (updateAction) {
            case massUpdateActions.COMPLETE_STOP:
                return [
                    ...defaultColumnHeaders,
                    { name: 'Attachments', localizationSlug: 'ATTACHMENT', count: 2 },
                    { name: 'Timestamp', localizationSlug: 'TIMESTAMP' },
                    { name: 'Timezone', localizationSlug: 'TIMEZONE' },
                    { name: 'Signatory', localizationSlug: 'SIGNATORY' },
                    { name: 'Seal Number', localizationSlug: 'SEAL_NUMBER' },
                    { name: 'Apply To All', localizationSlug: 'APPLY_TO_ALL' },
                    { name: 'Actions', localizationSlug: 'ACTION', count: 2 },
                ];
            case massUpdateActions.UPDATE_APPOINTMENT_WINDOW:
                return [
                    ...defaultColumnHeaders,
                    { name: 'Date/Appointment', localizationSlug: 'DATE_APPOINTMENT' },
                    { name: 'Confirm', localizationSlug: 'CONFIRM' },
                    { name: 'Apply To All', localizationSlug: 'APPLY_TO_ALL' },
                    { name: 'Actions', localizationSlug: 'ACTION', count: 2 },
                ];
            default:
                return [...defaultColumnHeaders];
        }
    }
    getValidationClass(stop, field) {
        const { status } = stop;
        if (status[field]) {
            return {
                error: true,
            };
        }
        return {
            error: false,
        };
    }
    handleInputChange(stopId, field, value) {
        // NOTE: Reset the reasonCode if new reason type selected
        if (field === 'reasonType') {
            this.props.onFieldChange(stopId, 'reasonCode', {});
        }
        this.props.onFieldChange(stopId, field, value);
    }
    ;
    renderRemoveActionColumn(stop) {
        const { _id: id } = stop;
        const key = `remove_${id}`;
        return (React.createElement("span", { key: key },
            React.createElement("button", { className: "button button-secondary", onClick: this.handleDeselectShipment(stop.job_id), disabled: this.props.actionsDisabled },
                React.createElement("i", { className: "fa fa-remove" }))));
    }
    renderDocumentUpload(stop) {
        var _a, _b, _c;
        const docUploadKey = `docUpload_${stop._id}`;
        const className = Object.assign({ 'w-max': true }, this.getValidationClass(stop, 'uri'));
        const { t } = this.props;
        /** NOTE: Don't render document upload if stop needs to capture arrival info only */
        if (ARRIVAL_STOP_TYPES.includes(((_a = this.props) === null || _a === void 0 ? void 0 : _a.action) || '')) {
            return (React.createElement("span", { className: "cursor-not-allowed text-gray-600 border p-2 rounded border-dashed opacity-75" }, t('ATTACHMENT_NOT_REQUIRED')));
        }
        return (React.createElement("span", { className: classnames(className), key: docUploadKey },
            React.createElement(DocumentUpload, { dropZoneClassNames: "px-4 py-2", uploadPending: stop.meta.uploadPending, uploadedFileUrl: (_c = (_b = stop.meta.uri) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.uri, onDrop: this.handleDrop(stop._id, stop.job_id) })));
    }
    renderDateInput(stop) {
        var _a, _b, _c;
        const datePickerKey = `datePicker_${stop._id}`;
        const className = Object.assign({ 'w-max': true }, this.getValidationClass(stop, 'date'));
        const { t } = this.props;
        const tz = ((_b = (_a = stop === null || stop === void 0 ? void 0 : stop.meta) === null || _a === void 0 ? void 0 : _a.timezone) === null || _b === void 0 ? void 0 : _b.value) || DEFAULT_TIMEZONE;
        const date = ((_c = stop === null || stop === void 0 ? void 0 : stop.meta) === null || _c === void 0 ? void 0 : _c.date) ? moment.tz(stop.meta.date, tz) : '';
        const { dateChanged = false } = stop;
        return (React.createElement("span", { key: datePickerKey, className: classnames(className) },
            React.createElement(DatePicker, { selected: dateChanged && mapDateValue(date), placeholderText: t('TIMESTAMP'), className: "w-full form-field", showTimeSelect: true, dateFormat: "L LT", timeIntervals: 30, timeCaption: t('COMPLETION_TIME'), onChange: this.handleDateFieldChange(stop._id, 'date') })));
    }
    renderTimezoneInput(stop) {
        var _a;
        const timezoneKey = `timezone_${stop._id}`;
        const className = Object.assign({ 'md:w-1/6': true }, this.getValidationClass(stop, 'timezone'));
        const timezone = (_a = stop === null || stop === void 0 ? void 0 : stop.meta) === null || _a === void 0 ? void 0 : _a.timezone;
        return (React.createElement("span", { key: timezoneKey, className: classnames(className) },
            React.createElement("div", null,
                React.createElement(CargomaticSelect, { hideLabel: true, selected: timezone === null || timezone === void 0 ? void 0 : timezone.value, onSelect: this.handleTimezoneChange(stop._id, 'timezone'), items: getTimezones(), value: timezone, valueKey: "value", textKey: "name" }))));
    }
    renderSignatory(stop) {
        var _a;
        const signatoryKey = `signatory_${stop._id}`;
        const className = Object.assign({ 'md:w-1/6': true }, this.getValidationClass(stop, 'signatory'));
        const { t } = this.props;
        /** NOTE: Don't render Signatory if stop needs to capture arrival info only */
        if (ARRIVAL_STOP_TYPES.includes(((_a = this.props) === null || _a === void 0 ? void 0 : _a.action) || '')) {
            return (React.createElement("span", null,
                React.createElement("div", { className: "w-max cursor-not-allowed text-gray-600 border p-2 rounded opacity-75" }, t('SIGNATORY_NOT_REQUIRED'))));
        }
        return (React.createElement("span", { key: signatoryKey, className: classnames(className) },
            React.createElement("input", { type: "text", className: "form-field w-max", value: stop.meta.signatory || '', onChange: this.handleFieldChange(stop._id, 'signatory'), placeholder: t('ENTER_SIGNATORY_DETAILS') })));
    }
    renderSealNumber(stop) {
        const signatoryKey = `seal_number_${stop._id}`;
        const className = Object.assign({ 'md:w-1/6': true }, this.getValidationClass(stop, 'seal_number'));
        const { t } = this.props;
        return (React.createElement("span", { key: signatoryKey, className: classnames(className) },
            React.createElement("input", { type: "text", className: "form-field w-max", value: stop.meta.sealNumber, onChange: this.handleFieldChange(stop._id, 'sealNumber'), placeholder: t('SEAL_NUMBER') })));
    }
    renderAppointmentWindow(stop) {
        const appointmentKey = `appointment_${stop._id}`;
        const className = {
            'md:w-full': true,
        };
        return (React.createElement("div", { className: classnames(className), key: appointmentKey },
            React.createElement(AppointmentWindow, { window_start: mapDateValue(stop.meta.window_start), window_end: mapDateValue(stop.meta.window_end), status: stop.status, appointment: stop.meta.appointment, onWindowStartChange: this.handleWindowStartChange(stop._id), onWindowEndChange: this.handleWindowEndChange(stop._id), onAppointmentChange: this.handleAppointmentChange(stop._id), onEnableAppointmentTimes: this.handleEnableAppointmentTimes(stop._id) })));
    }
    renderConfirmCheckbox(stop) {
        const confirmKey = `confirm_${stop.action}-${stop.empty}_appointment_${stop._id}`;
        return (React.createElement("span", { key: confirmKey, className: "ml-4" },
            React.createElement(CargomaticInput, { type: "checkbox", hideLabel: true, value: stop.meta.confirm_appointment, onChange: (checked) => {
                    this.handleAppointmentConfirmationChange(stop._id, checked);
                } })));
    }
    renderReasonType(stop) {
        var _a, _b, _c;
        const reasonTypeKey = `reasonTypeKey_${stop.action}-${stop.empty}_${stop._id}`;
        const className = Object.assign({}, this.getValidationClass(stop, 'reasonType'));
        const { t } = this.props;
        return (React.createElement("span", { key: reasonTypeKey, className: classnames(className) },
            React.createElement(CargomaticSelect, { showCaption: true, labelClassName: "font-bold text-grey-darker", label: t('REASON_TYPE'), caption: t('REASON_TYPE_CAPTION'), items: ((_a = stop === null || stop === void 0 ? void 0 : stop.reasonCodes) === null || _a === void 0 ? void 0 : _a.subCategories) || [], valueKey: "reasonType", textKey: "reasonType", selected: ((_c = (_b = stop === null || stop === void 0 ? void 0 : stop.meta) === null || _b === void 0 ? void 0 : _b.reasonType) === null || _c === void 0 ? void 0 : _c.reasonType) || '', onSelect: (value) => { this.handleInputChange(stop._id, 'reasonType', value); } })));
    }
    renderReasonCode(stop) {
        var _a, _b, _c, _d;
        const reasonCodeKey = `reasonCodeKey_${stop.action}-${stop.empty}_${stop._id}`;
        const className = Object.assign({}, this.getValidationClass(stop, 'reasonCode'));
        const { t } = this.props;
        return (React.createElement("span", { key: reasonCodeKey, className: classnames(className) },
            React.createElement(CargomaticSelect, { labelClassName: "font-bold text-grey-darker", label: t('REASON_CODE'), caption: t('SELECT_REASON_CODE'), items: ((_b = (_a = stop === null || stop === void 0 ? void 0 : stop.meta) === null || _a === void 0 ? void 0 : _a.reasonType) === null || _b === void 0 ? void 0 : _b.reasonCodes) || [], showCaption: true, valueKey: 'code', textKey: "description", selected: ((_d = (_c = stop === null || stop === void 0 ? void 0 : stop.meta) === null || _c === void 0 ? void 0 : _c.reasonCode) === null || _d === void 0 ? void 0 : _d.code) || '', onSelect: (value) => { this.handleInputChange(stop._id, 'reasonCode', value); } })));
    }
    renderComment(stop) {
        var _a;
        const commentKey = `commentKey_${stop.action}-${stop.empty}_${stop._id}`;
        const className = Object.assign({}, this.getValidationClass(stop, 'message'));
        const { t } = this.props;
        return (React.createElement("span", { key: commentKey, className: classnames(className) },
            React.createElement(CargomaticInput, { labelClassName: "font-bold text-grey-darker", label: t('COMMENT'), type: "text", placeholder: t('ADD_A_COMMENT'), value: ((_a = stop === null || stop === void 0 ? void 0 : stop.meta) === null || _a === void 0 ? void 0 : _a.message) || '', onChange: (value) => { this.handleInputChange(stop._id, 'message', value); } })));
    }
    renderDocumentUploadAndReasonType(stop) {
        return (React.createElement("span", null,
            React.createElement("div", { className: 'flex flex-col h-36 justify-between w-min' },
                this.renderDocumentUpload(stop),
                this.renderReasonType(stop))));
    }
    renderDateInputAndReasonCode(stop) {
        return (React.createElement("span", { className: 'flex flex-col h-36 justify-between w-min' },
            this.renderDateInput(stop),
            this.renderReasonCode(stop)));
    }
    renderChassisNumber(stop) {
        var _a, _b, _c;
        const { t } = this.props;
        const stopId = stop._id;
        const chassis = (_a = stop === null || stop === void 0 ? void 0 : stop.equipments) === null || _a === void 0 ? void 0 : _a.find(eq => eq._equipmentType === 'chassis');
        const hasChassis = !!chassis;
        const className = Object.assign({ 'w-max': true }, this.getValidationClass(stop, 'chassis'));
        const currentValue = hasChassis ? chassis === null || chassis === void 0 ? void 0 : chassis.equipment_id : (_c = (_b = stop === null || stop === void 0 ? void 0 : stop.meta) === null || _b === void 0 ? void 0 : _b.chassis) === null || _c === void 0 ? void 0 : _c.equipment_id;
        return (React.createElement("span", { className: classnames(className) },
            React.createElement(CargomaticInput, { label: `${t('CHASSIS_NUMBER_LENGTH', {
                    validLength: CHASSIS_ID_VALID_LENGTH,
                })}`, "data-testid": "chassisNumberInput", disabled: hasChassis, type: "text", placeholder: t('CHASSIS_NUMBER_REQUIRED'), onChange: (value) => this.handleChassisChange(stopId, value), value: currentValue || '' })));
    }
    renderEquipmentAndChassisNumber(stop) {
        return (React.createElement("span", { className: 'flex flex-col h-36 justify-between w-min' },
            formatEquipments(stop),
            stop.shipment_type === "drayage" && this.renderChassisNumber(stop)));
    }
    renderTimezoneInpuAndComment(stop) {
        return (React.createElement("span", { className: 'flex flex-col h-36 justify-between w-max' },
            this.renderTimezoneInput(stop),
            this.renderComment(stop)));
    }
    renderReferenceNumbers(stop) {
        var _a;
        if (!featureEnabled(CONFIGURED_FEATURES.SSR) || !((_a = stop === null || stop === void 0 ? void 0 : stop.missingReferenceNumbers) === null || _a === void 0 ? void 0 : _a.length)) {
            return null;
        }
        const { t, referenceNumberUpdates, onReferenceNumberUpdate } = this.props;
        const { job_id, missingReferenceNumbers, } = stop;
        return (missingReferenceNumbers || []).map((ref, index) => {
            const gridColumnStart = index === 0 ? 4 : null;
            const label = t(ref === null || ref === void 0 ? void 0 : ref.toUpperCase());
            const referenceValue = referenceNumberUpdates[job_id] && referenceNumberUpdates[job_id][ref];
            return (React.createElement("span", { className: "relative mb-4", style: { gridColumnStart } },
                React.createElement(CargomaticInput, { label: label, "data-testid": `${ref}_test_id`, type: "text", placeholder: label, onChange: (value) => onReferenceNumberUpdate(job_id, ref, value), value: referenceValue })));
        });
    }
    renderStopCompleteColumns(stop) {
        return [
            ...this.renderDefaultColumns(stop),
            this.renderDocumentUploadAndReasonType(stop),
            this.renderDateInputAndReasonCode(stop),
            this.renderTimezoneInpuAndComment(stop),
            this.renderSignatory(stop),
            this.renderSealNumber(stop),
            this.renderApplyToAllButton(stop),
            this.renderRemoveActionColumn(stop),
            this.renderReferenceNumbers(stop)
        ];
    }
    renderStopAppointmentColumns(stop) {
        return [
            ...this.renderDefaultColumns(stop),
            this.renderAppointmentWindow(stop),
            this.renderConfirmCheckbox(stop),
            this.renderApplyToAllButton(stop),
            this.renderRemoveActionColumn(stop),
        ];
    }
    renderColumns(stop) {
        const { updateAction } = this.props;
        switch (updateAction) {
            case massUpdateActions.COMPLETE_STOP:
                return this.renderStopCompleteColumns(stop);
            case massUpdateActions.UPDATE_APPOINTMENT_WINDOW:
                return this.renderStopAppointmentColumns(stop);
            default:
                return this.renderDefaultColumns(stop);
        }
    }
    renderApplyToAllButton(stop) {
        const applyAllKey = `apply_${stop._id}`;
        const buttonClassName = {
            button: true,
            'button-hollow-green': true,
        };
        const { actionsDisabled, t } = this.props;
        const disabled = actionsDisabled || stop.meta.applyAllDisabled;
        return (React.createElement("div", { key: applyAllKey },
            React.createElement("button", { type: "button", className: classnames(buttonClassName), onClick: this.handleApplyToAll(stop._id), disabled: disabled }, titleize(t('APPLY')))));
    }
    renderStop(stop) {
        const columns = this.renderColumns(stop);
        return columns;
    }
    renderHeader() {
        const { t } = this.props;
        const columnHeaders = this.getHeaders();
        return (columnHeaders.map((col) => (React.createElement("p", { key: col.name, className: "font-bold text-grey-darker" }, titleize(t(col.localizationSlug, { count: col.count || 1 }))))));
    }
    renderBody() {
        const { stops } = this.props;
        return stops.map((stop) => this.renderStop(stop));
    }
    renderStatuses() {
        const { status } = this.props;
        if (!status || status.length === 0) {
            return null;
        }
        return (React.createElement("div", { className: "flex flex-col mr-4 stop-status-wrapper" }, status.map((s) => renderStatus(s))));
    }
    renderDefaultColumns(stop) {
        const { _id: id, job_id } = stop;
        const idKey = `id_${id}`;
        const addressKey = `address_${id}`;
        const shipperNameKey = `shipper_${id}`;
        const equipmentsKey = `equipments_${id}`;
        const shipmentLink = `/shipments/${job_id}`;
        return [
            React.createElement("p", { key: idKey, style: { gridColumnStart: 1 } },
                React.createElement("a", { href: shipmentLink, target: "_blank", rel: "noopener noreferrer" }, stop.shipment_id)),
            React.createElement("p", { key: addressKey }, formatAddress(stop)),
            React.createElement("p", { className: "w-max", key: shipperNameKey }, stop.shipper_name),
            React.createElement("p", { key: equipmentsKey }, this.renderEquipmentAndChassisNumber(stop)),
        ];
    }
    render() {
        const { title, saveInProgress, actionsDisabled, t, stops, updateAction } = this.props;
        const isStopCompleteAction = updateAction === massUpdateActions.COMPLETE_STOP;
        const dateChangeDisabled = isStopCompleteAction ? !stops.every((s) => s.dateChanged) : false;
        const buttonDisabled = saveInProgress || actionsDisabled;
        const gridClass = classnames({
            grid: true,
            'mb-4': true,
            'gap-2': isStopCompleteAction,
            'gap-1': !isStopCompleteAction,
        });
        const gridStyle = {
            gridTemplateColumns: isStopCompleteAction ? 'repeat(11, 2fr)' : '0.5fr 1fr 0.5fr repeat(2, 1.5fr) repeat(3, 0.5fr)'
        };
        return (React.createElement("div", { className: "p-4 mb-6 bg-white shadow" },
            React.createElement("div", { className: "flex justify-between" },
                React.createElement("h4", { className: "mb-2 text-grey-darker" }, t(sluggify(title)))),
            React.createElement("hr", null),
            React.createElement("div", { className: "stop-rows overflow-scroll" },
                React.createElement("div", { className: gridClass, style: gridStyle },
                    this.renderHeader(),
                    this.renderBody()),
                React.createElement("div", { className: "flex items-baseline justify-end" },
                    this.renderStatuses(),
                    React.createElement("button", { className: "mr-2 button button-hollow-green", disabled: buttonDisabled, onClick: this.handleClearAll }, t('CLEAR_ALL')),
                    React.createElement("button", { className: `button button-green flex items-center unifiedView-masterList-${this.props.updateAction} heap`, disabled: buttonDisabled || dateChangeDisabled, onClick: this.handleSaveAll },
                        saveInProgress && (React.createElement("div", { className: "flex items-center mr-2" },
                            React.createElement("i", { className: "fa fa-spinner fa-spin" }))),
                        React.createElement("span", null, this.getActionName()))))));
    }
}
StopsGroup.propTypes = {
    actionsDisabled: PropTypes.bool,
    saveInProgress: PropTypes.bool,
    title: PropTypes.string,
    action: PropTypes.string,
    updateAction: PropTypes.oneOf([
        massUpdateActions.COMPLETE_STOP,
        massUpdateActions.UPDATE_APPOINTMENT_WINDOW,
        '',
    ]),
    status: PropTypes.array,
    stops: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string,
        shipment_id: PropTypes.string,
        job_id: PropTypes.string,
        shipper_name: PropTypes.string,
        carrier_name: PropTypes.string,
        location: PropTypes.arrayOf(PropTypes.shape({
            address: PropTypes.string,
        })),
        equipments: PropTypes.arrayOf(PropTypes.shape({
            _id: PropTypes.string,
            equipment_id: PropTypes.string,
        })),
        meta: PropTypes.shape({
            uploadPending: PropTypes.bool,
        }),
    })),
    onClearAll: PropTypes.func.isRequired,
    onDeselectShipment: PropTypes.func.isRequired,
    onSaveAll: PropTypes.func.isRequired,
    onApplyToAll: PropTypes.func.isRequired,
    onFieldChange: PropTypes.func.isRequired,
    onDocumentDrop: PropTypes.func.isRequired,
    onAppointmentChange: PropTypes.func.isRequired,
    onAppointmentConfirmationChange: PropTypes.func.isRequired,
};
StopsGroup.defaultProps = {
    saveInProgress: false,
    actionsDisabled: false,
    status: [],
};
function renderStatus(status) {
    switch (status.type) {
        case 'error':
            return (React.createElement(ErrorAlert, { key: status.type, title: status.message }, status.items.length && (React.createElement("ul", null, status.items.map((id) => (React.createElement("li", { key: id }, id)))))));
        case 'success':
            return (React.createElement("div", { className: "p-4 mb-4 border-l-4 border-solid border-green bg-green-lightest text-green-darker" },
                React.createElement("p", { className: "mb-2 font-bold" }, status.message),
                status.items.length && (React.createElement("ul", null, status.items.map((id) => (React.createElement("li", { key: id }, id)))))));
        default:
            return null;
    }
}
function formatAddress(stop) {
    const location = (stop.location || [])[0] || {};
    return location.address || i18next.t('NO_ADDRESS_SET');
}
function formatEquipments(stop) {
    const equipments = stop.equipments || [];
    if (equipments.length === 0) {
        return titleize(i18next.t('NONE'));
    }
    return (React.createElement("ul", null, stop.equipments.map((e) => (React.createElement("li", { className: "mb-2", key: e._id }, e.equipment_id)))));
}
function mapDateValue(value) {
    if (!value) {
        return null;
    }
    if (value instanceof moment) {
        return value;
    }
    return moment(value);
}
export default withTranslation()(StopsGroup);
